import styled, { css } from 'styled-components';

const StyledTree = /*#__PURE__*/styled('ul').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-0"
})(["list-style:none;display:flex;flex-direction:column;justify-content:space-evenly;padding-inline:0;margin:0;&&[role=\"tree\"]{border:", ";", " ", " border-radius:", ";&& > li:first-child > div{border-start-start-radius:", ";border-start-end-radius:", ";}&& > li:last-child > div{border-end-start-radius:", ";border-end-end-radius:", ";}}"], ({
  theme
}) => theme.border.subtle.default, ({
  theme,
  status
}) => status === 'error' && css(["border:", ";"], theme.support.border.error), ({
  theme,
  status
}) => status === 'warning' && css(["border:", ";"], theme.support.border.warning), ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large);
const StyledTreeList = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-1"
})(["", " :not(:last-child){border-block-end:", ";}"], ({
  theme,
  $root,
  $displayed
}) => $root && $displayed && css(["padding-block-end:", ";"], theme.spacing.xxsmall.default), ({
  theme,
  $root
}) => $root ? theme.border.subtle.default : 'none');
const ActionBarWrapper = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-2"
})(["padding:", ";border-block-end:", ";"], ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.border.subtle.default);
const OuterNode = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-3"
})(["display:flex;padding-inline:", ";", ";:hover{background-color:", ";}"], ({
  theme
}) => theme.spacing.xsmall.default, ({
  $root
}) => $root && css(["gap:", ";"], ({
  theme
}) => theme.spacing.xxsmall.default), ({
  theme
}) => theme.surface.container.hover);
const InnerNode = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-4"
})(["display:flex;flex-grow:1;gap:", ";"], ({
  theme
}) => theme.spacing.xxsmall.default);
const RenderNodeWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-5"
})(["display:flex;flex-grow:1;padding-block-start:", ";padding-inline-end:", ";padding-block-end:", ";padding-inline-start:0px;"], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default);
const OverrideWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-128h40x-6"
})(["display:flex;justify-content:center;align-items:center;padding:", ";"], ({
  theme
}) => theme.spacing.small.default);

export { ActionBarWrapper as A, InnerNode as I, OverrideWrapper as O, RenderNodeWrapper as R, StyledTree as S, StyledTreeList as a, OuterNode as b };
//# sourceMappingURL=Tree.styles-BemGaCJZ.js.map
